import { FulfillmentOptionsCardProp } from '@springbig/shared';
import React from 'react';
import { VStack } from 'native-base';
import { Button } from '~/shared/Theme';

export type FulfillmentOptionsProps = {
    setFullfillmentOption: (value: FulfillmentOptionsCardProp) => void;
    fullfillmentOptions: Array<FulfillmentOptionsCardProp>;
    selectedFulfillmentOption: FulfillmentOptionsCardProp;
};

export const FullfillmentOptions = ({
    setFullfillmentOption,
    fullfillmentOptions,
    selectedFulfillmentOption,
}:  FulfillmentOptionsProps) => {

    return (
        <VStack space={2}>
            { fullfillmentOptions.map((item, index) => (

                <Button
                    key={index}
                    variant={selectedFulfillmentOption?.label === item.label ? 'button' : 'neutral'}
                    text={item.label}
                    onPress={() => setFullfillmentOption(item)}
                />
            ))}
        </VStack>
    );
};
